import { useEffect, useMemo, useState } from 'react';
import { useFilters } from '@elfsight/widget-filters';
import type { SalaryPeriod } from '../../../types';
import { getMostFrequentString } from './getMostFrequentString';
import { useAmountSalaries } from './useAmountSalaries';

export function useCurrencyAndPeriodSelection() {
  const amountSalaries = useAmountSalaries();
  const { setFilterValue, setAppliedFilterValue } = useFilters();

  const { popularCurrency, popularPeriod } = useMemo(() => {
    const currencies: string[] = [];
    const periods: SalaryPeriod[] = [];

    amountSalaries.forEach(({ currency, period }) => {
      currencies.push(currency);
      periods.push(period);
    });

    return {
      popularCurrency: getMostFrequentString(currencies),
      popularPeriod: getMostFrequentString(periods)
    };
  }, [amountSalaries]);

  const [selectedCurrency, setSelectedCurrency] = useState(popularCurrency);
  const [selectedPeriod, setSelectedPeriod] =
    useState<SalaryPeriod>(popularPeriod);

  useEffect(() => setSelectedCurrency(popularCurrency), [popularCurrency]);
  useEffect(() => setSelectedPeriod(popularPeriod), [popularPeriod]);

  useEffect(() => {
    setFilterValue('salary', () => []);
    setAppliedFilterValue('salary', () => []);
  }, [selectedCurrency, selectedPeriod]);

  return {
    selectedCurrency,
    selectedPeriod,
    setSelectedCurrency,
    setSelectedPeriod
  } as const;
}
